function changeColor() {
  const titles = document.querySelectorAll('.category-hierarchy-title');
  titles.forEach(title => {
    title.style = "color:#001922";
 });
}

const formatCategoryName = (categoryName) => {
  let parts = categoryName.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());

  for (let i = 0; i < parts.length; i++) {
      if (parts[i] === "&" && i > 0 && i < parts.length - 1) {
          parts[i-1] += " & " + parts[i+1];
          parts.splice(i, 2);
      }
  }

  return parts.join(' ');
}

window.SEARCH_API_KEY = "8M7F2Q8V2q"
let SEARCH_API_FILTERS = {
  'brands': 'filter_metafield_0b07138eb04251d8eccf9629329de9ac',
  'concerns': 'filter_ptag_09099cd3cfde27c53f26ec6894490764',
  'ingredients': 'filter_ptag_1b83527fc8a3a3b1973974b68df87d1f',
  'top_category': 'filter_metafield_b6ce6d7f183137af6db4cc18686c5d35',
  'secondary_category': 'filter_metafield_709549de28dc2265d6b068ab7c926790',
  'tertiary_category': 'filter_metafield_2a03faa97fc11af0069411b993d2ad11'
}

if (window.shopPermanentUrl === 'next-world.myshopify.com') {
  window.SEARCH_API_KEY = "7b9t5Q2i4z"
}

let rootCategorySplit = ''

function handleCategoryHierarchy(organizedData) {
  rootCategorySplit = (COLLECTION_ROOT_CATEGORY || '').split(",").map(item => formatCategoryName(item.trim()))

  if (!COLLECTION_ROOT_CATEGORY && !COLLECTION_TITLE && Object.keys(organizedData).length === 1) {
    // for search force set rootCategory if we can
    rootCategorySplit = Object.keys(organizedData)
    if (Object.keys(organizedData[rootCategorySplit[0]]).length === 1) {
      rootCategorySplit.push(Object.keys(organizedData[rootCategorySplit[0]])[0])
    }
  }

  console.log('handleCategoryHierarchy')
  console.log('rootCategorySplit: ', rootCategorySplit)
  console.log('organizedData: ', organizedData)

  if (Object.keys(organizedData).includes(rootCategorySplit[0]) && Object.keys(organizedData[rootCategorySplit[0]]).includes(rootCategorySplit[1])) {
    // root category is something like "makeup, eyes"
    const subcategories = organizedData[rootCategorySplit[0]][rootCategorySplit[1]]

    const wrappers = document.querySelectorAll('.category-hierarchy__wrapper')

    wrappers.forEach(wrapper => {
      wrapper.innerHTML = ''

      const newDetailsEl = document.createElement('details')
      newDetailsEl.classList.add('category-hierarchy')
      newDetailsEl.setAttribute('open', 'true')
      newDetailsEl.dataset.type = rootCategorySplit[1]

      const newSummaryEl = document.createElement('summary')
      newSummaryEl.classList.add('category-hierarchy-title')
      newSummaryEl.innerHTML = `<span>All ${COLLECTION_TITLE || rootCategorySplit[1]}</span>`

      const newItemsContainer = document.createElement('div')
      newItemsContainer.classList.add('category-hierarchy-items')

      newDetailsEl.appendChild(newSummaryEl)
      newDetailsEl.appendChild(newItemsContainer)

      newDetailsEl.addEventListener('click', () => {
        const searchParams = new URLSearchParams(window.location.search)
        searchParams.set('category', 'null')
        searchParams.delete('secondary')

        updatePageFilter(searchParams)
      })

      wrapper.appendChild(newDetailsEl)

      const organizedSecondary = subcategories.sort((a, b) => {
        return a.toLowerCase().localeCompare(b.toLowerCase())
      })

      organizedSecondary.forEach(secondary => {
        const itemElement = document.createElement('a')
        itemElement.classList.add('category-hierarchy-item')
        itemElement.innerText = secondary
        itemElement.dataset.type = secondary
        itemElement.href = ''
        newItemsContainer.appendChild(itemElement)
      })
    })
  }
  else if (Object.keys(organizedData).includes(rootCategorySplit[0])) {
    // root category is something like "makeup"
    const subcategories = organizedData[rootCategorySplit[0]]

    const wrappers = document.querySelectorAll('.category-hierarchy__wrapper')

    wrappers.forEach(wrapper => {
      wrapper.innerHTML = ''

      const newDetailsEl = document.createElement('details')
      newDetailsEl.classList.add('category-hierarchy')
      newDetailsEl.setAttribute('open', 'true')
      newDetailsEl.dataset.type = rootCategorySplit[0]

      const newSummaryEl = document.createElement('summary')
      newSummaryEl.classList.add('category-hierarchy-title')
      newSummaryEl.innerHTML = `<span>All ${COLLECTION_TITLE || rootCategorySplit[0]}</span>`

      const newItemsContainer = document.createElement('div')
      newItemsContainer.classList.add('category-hierarchy-items')

      newDetailsEl.appendChild(newSummaryEl)
      newDetailsEl.appendChild(newItemsContainer)

      newDetailsEl.addEventListener('click', () => {
        const searchParams = new URLSearchParams(window.location.search)
        searchParams.set('category', 'null')
        searchParams.delete('secondary')

        updatePageFilter(searchParams)
      })

      wrapper.appendChild(newDetailsEl)

      const organizedSecondary = Object.keys(subcategories).sort((a, b) => {
        return a.toLowerCase().localeCompare(b.toLowerCase())
      })

      organizedSecondary.forEach(secondary => {
        const itemElement = document.createElement('a')
        itemElement.classList.add('category-hierarchy-item')
        itemElement.innerText = secondary
        itemElement.dataset.type = secondary
        itemElement.href = ''
        newItemsContainer.appendChild(itemElement)
      })
    })
  }
  else {
    // no root category set, we need to go through the visible hierarchy and prune it
    const acceptableTypes = Object.keys(organizedData)
    const allHierarchies = document.querySelectorAll('.category-hierarchy')
    allHierarchies.forEach(hierarchy => {
      if (!acceptableTypes.includes(hierarchy.dataset.type)) {
        hierarchy.remove()
      }
    })

    for (let topLevel in organizedData) {
      const summaryGroups = document.querySelectorAll(`details.category-hierarchy[data-type="${topLevel}"]`);

      summaryGroups.forEach(summaryGroup => {
        const itemsContainer = summaryGroup.querySelector('.category-hierarchy-items')

        // Clear existing items if needed
        itemsContainer.innerHTML = ''

        const organizedSecondary = Object.keys(organizedData[topLevel]).sort((a, b) => {
          return a.toLowerCase().localeCompare(b.toLowerCase())
        })

        organizedSecondary.forEach(secondary => {
          const itemElement = document.createElement('a')
          itemElement.classList.add('category-hierarchy-item')
          itemElement.innerText = secondary
          itemElement.dataset.type = secondary
          itemElement.href = ''
          itemsContainer.appendChild(itemElement)
        });
      })
    }
  }

  // If there's only one top level category go ahead and open it
  if (Object.keys(organizedData).length === 1) {
    const singleTopLevel = Object.keys(organizedData)[0]
    const detailsElement = document.querySelectorAll(`details.category-hierarchy[data-type="${singleTopLevel}"]`)

    detailsElement.forEach(detailsElement => {
      detailsElement.setAttribute('open', 'true')
    })
  }

  const detailsElements = document.querySelectorAll('details.category-hierarchy')

  detailsElements.forEach(detailsElement => {
    if (!detailsElement.dataset.type) { return }

    const secondaryItems = detailsElement.querySelectorAll('.category-hierarchy-item')

    detailsElement.addEventListener('click', () => {
      const searchParams = new URLSearchParams(window.location.search)
      searchParams.set('category', 'null')
      searchParams.delete('secondary')

      if (detailsElement.dataset.type) {
        searchParams.set('category', detailsElement.dataset.type)
      }

      const allItems = document.querySelectorAll('.category-hierarchy-item')
      allItems.forEach(item => {
        item.classList.remove('selected')
      })

      updatePageFilter(searchParams)
    })

    secondaryItems.forEach(secondaryItem => {

      secondaryItem.addEventListener('click', (event) => {
        event.stopImmediatePropagation()
        event.preventDefault()

        const searchParams = new URLSearchParams(window.location.search)
        searchParams.set('category', detailsElement.dataset.type)
        searchParams.set('secondary', secondaryItem.dataset.type)
        searchParams.delete('page') // Resets page to first

        updatePageFilter(searchParams)

        const allItems = document.querySelectorAll('.category-hierarchy-item')
        allItems.forEach(item => {
          item.classList.remove('selected')
        })

        secondaryItem.classList.add('selected')

        return false
      })

    })
  })
}

function formatMoney(price, currency = 'USD') {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency }).format(price).replace('.00', '')
}

function renderFilterProducts(products) {
  const productGrid = document.querySelector('#product-grid')

  const gridItemTemplate = document.querySelector('#product-grid-item-template').innerText

  const formattedProducts = products.map(product => {
    const image1 = product.shopify_images && product.shopify_images[0] ? product.shopify_images[0] : '';
    const imageAlt1 = product.shopify_images_alt && product.shopify_images_alt[0] ? product.shopify_images_alt[0] : '';
    const image2 = product.shopify_images && product.shopify_images[1] ? product.shopify_images[1] : '';
    const imageAlt2 = product.shopify_images_alt && product.shopify_images_alt[1] ? product.shopify_images_alt[1] : '';

    return {
      image: image1,
      image_alt: imageAlt1,
      image_2: image2 || image1,
      image_alt_2: imageAlt2 || imageAlt1,
      title: product.title,
      vendor: product.vendor,
      link: product.link,
      price: formatMoney(product.price),
      first_variant_id: product.add_to_cart_id
    }
  })

  // #TODO: MAINTAIN E-SPOT DIVS AND LOCATIONS

  productGrid.innerHTML = '';

  formattedProducts.forEach(product => {
    const newTile = document.createElement('div')

    let template = gridItemTemplate
    template = template.replace(/\[\[VARIANT_ID\]\]/g, product.first_variant_id)
    template = template.replace(/\[\[PRODUCT_IMAGE_SRC_1\]\]/g, product.image)
    template = template.replace(/\[\[PRODUCT_IMAGE_ALT_1\]\]/g, product.image_alt)
    template = template.replace(/\[\[PRODUCT_IMAGE_SRC_2\]\]/g, product.image_2)
    template = template.replace(/\[\[PRODUCT_IMAGE_ALT_2\]\]/g, product.image_alt_2)
    template = template.replace(/\[\[PRODUCT_TITLE\]\]/g, product.title)
    template = template.replace(/\[\[PRODUCT_VENDOR\]\]/g, product.vendor)
    template = template.replace(/\[\[PRODUCT_LINK\]\]/g, product.link)
    template = template.replace(/\[\[PRODUCT_PRICE_REGULAR\]\]/g, product.price)
    template = template.replace(/\[\[PRODUCT_PRICE_SALE\]\]/g, product.price)

    newTile.innerHTML = template

    productGrid.appendChild(newTile.firstElementChild)
  })
}

function updatePagination(response) {
  const paginationWrapper = document.querySelector('.product-grid-container .pagination__wrapper')

  if (!paginationWrapper) {
    return
  }

  // reset the HTML for the paginationWrapper so we get rid of all old event listeners
  const cachedInnerHtml = paginationWrapper.innerHTML
  paginationWrapper.innerHTML = ''
  paginationWrapper.innerHTML = cachedInnerHtml

  const { currentPage, numPages } = calculatePageInfo(response)

  const infoText = paginationWrapper.querySelector('.pagination__info')
  infoText.innerText = `Page ${currentPage} of ${numPages}`

  const prevContainer = paginationWrapper.querySelector('.pagination__previous')

  if (currentPage === 1) {
    prevContainer.classList.add('disabled')
    prevContainer.classList.remove('enabled')

    const prevLinks = prevContainer.querySelectorAll('a')

    prevLinks.forEach(link => {
      link.addEventListener('click', (event) => {
        event.preventDefault()
        return false
      })
    })
  } else {
    prevContainer.classList.add('enabled')
    prevContainer.classList.remove('disabled')

    const jumpToBeginning = prevContainer.querySelector('.jump-to-beginning')
    const prevButton = prevContainer.querySelector('.previous_inner')

    jumpToBeginning.addEventListener('click', (event) => {
      event.preventDefault()

      const searchParams = new URLSearchParams(window.location.search)
      searchParams.set('page', 1)

      updatePageFilter(searchParams)

      return false
    })

    prevButton.addEventListener('click', (event) => {
      event.preventDefault()

      const searchParams = new URLSearchParams(window.location.search)
      searchParams.set('page', currentPage - 1)

      updatePageFilter(searchParams)

      return false
    })
  }

  const nextContainer = paginationWrapper.querySelector('.pagination__next')

  if (currentPage === numPages) {
    nextContainer.classList.add('disabled')
    nextContainer.classList.remove('enabled')

    const nextLinks = nextContainer.querySelectorAll('a')

    nextLinks.forEach(link => {
      link.addEventListener('click', (event) => {
        event.preventDefault()
        return false
      })
    })
    /* Scroll for the last page */
    const collectionMainWrapper = document.querySelector('.main-collection_wrapper')
    if (collectionMainWrapper) {
      collectionMainWrapper.scrollIntoView({ behavior: 'smooth' })
    } else {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
    }
  } else {
    nextContainer.classList.add('enabled')
    nextContainer.classList.remove('disabled')

    const jumpToEnd = nextContainer.querySelector('.jump-to-end')
    const nextButton = nextContainer.querySelector('.next_inner')

    jumpToEnd.addEventListener('click', (event) => {
      event.preventDefault()

      const searchParams = new URLSearchParams(window.location.search)
      searchParams.set('page', numPages)

      updatePageFilter(searchParams)

      return false
    })

    nextButton.addEventListener('click', (event) => {
      event.preventDefault()

      const searchParams = new URLSearchParams(window.location.search)
      searchParams.set('page', currentPage + 1)

      updatePageFilter(searchParams)

      return false
    })
  }

}

function updateFiltersFromFacets(facets, currentFilters, fromInitialLoad = false) {
  function updateFilterValues(type, all_values) {
    // try to find the first input value with name type
    const firstInput = document.querySelector(`#FacetFiltersForm input[name='${type}']`)
    const firstInputMobile = document.querySelector(`#FacetFiltersFormMobile input[name='${type}']`)

    if (!firstInput || !firstInputMobile) {
      return
    }

    let queryType = type
    if (type === 'brands') {
      queryType = 'brands'
    } else if (type === 'concern-need') {
      queryType = 'concerns'
    } else if (type === 'ingredient') {
      queryType = 'ingredients'
    }

    const detailsEl = firstInput.closest('details')
    const detailsElMobile = firstInputMobile.closest('details')

    if (!detailsEl || !detailsElMobile) {
      console.log('details not found')
      return
    }

    // delete all the current entries
    const allInputs = detailsEl.querySelectorAll('li.facets__item')
    const allMobileInputs = detailsElMobile.querySelectorAll('li.facets__item')

    allInputs.forEach(input => {
      input.remove()
    })

    allMobileInputs.forEach(input => {
      input.remove()
    })

    const inputElementTemplate = `<li class="list-menu__item facets__item">
    <label for="[[FILTER_ID]]" class="facet-checkbox">
        <input type="checkbox" name="[[FILTER_TYPE]]" value="[[FILTER_NAME]]" id="[[FILTER_ID]]">
        <svg aria-hidden="true" class="icon icon-checkmark" width="11px" height="7px" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.5 3.5L2.83333 4.75L4.16667 6L9.5 1" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
        <span class="facet-checkbox-text" aria-hidden="true">[[FILTER_NAME]]</span>
        <span class="visually-hidden">[[FILTER_NAME]]</span>
    </label>
</li>`

    const listContainer = detailsEl.querySelector('ul.facets__list')
    const listContainerMobile = detailsElMobile.querySelector('ul.facets__list')

    all_values.forEach((value, index) => {
      const newEl = document.createElement('div')

      let template = inputElementTemplate
      template = template.replace(/\[\[FILTER_TYPE\]\]/g, type)
      template = template.replace(/\[\[FILTER_ID\]\]/g, `Filter-${type}-${index + 1}`)
      template = template.replace(/\[\[FILTER_NAME\]\]/g, value)

      newEl.innerHTML = template

      if (index > 10) {
        newEl.firstElementChild.classList.add('show-more-item')
        newEl.firstElementChild.classList.add('hidden')
      }

      if (currentFilters.get(queryType) && currentFilters.get(queryType).split('|').includes(value)) {
        newEl.firstElementChild.querySelector('input').checked = true
      }

      listContainer.appendChild(newEl.firstElementChild.cloneNode(true))
      listContainerMobile.appendChild(newEl.firstElementChild.cloneNode(true))
    })

    const desktopSearchInput = detailsEl.querySelector('.facets__search-input')
    const mobileSearchInput = detailsElMobile.querySelector('.facets__search-input')

    if (desktopSearchInput) {
      desktopSearchInput.addEventListener('input', (event) => {
        const searchTerm = event.target.value.toLowerCase()

        const allItems = detailsEl.querySelectorAll('li.facets__item')

        allItems.forEach(item => {
          const itemText = item.querySelector('.facet-checkbox-text').innerText.toLowerCase()

          if (itemText.includes(searchTerm)) {
            item.classList.remove('hidden')
          } else {
            item.classList.add('hidden')
          }
        })

        const visibleItems = detailsEl.querySelectorAll('li.facets__item:not(.hidden)')
        if (visibleItems.length === 0) {
          allItems.forEach(item => {
            item.classList.remove('hidden')
          })
        }
      })
    }

    if (mobileSearchInput) {
      mobileSearchInput.addEventListener('input', (event) => {
        const searchTerm = event.target.value.toLowerCase()

        const allItems = detailsElMobile.querySelectorAll('li.facets__item')

        allItems.forEach(item => {
          const itemText = item.querySelector('.facet-checkbox-text').innerText.toLowerCase()

          if (itemText.includes(searchTerm)) {
            item.classList.remove('hidden')
          } else {
            item.classList.add('hidden')
          }
        })

        const visibleItems = detailsElMobile.querySelectorAll('li.facets__item:not(.hidden)')
        if (visibleItems.length === 0) {
          allItems.forEach(item => {
            item.classList.remove('hidden')
          })
        }
      })
    }
  }

  const brandsFacets = facets.filter(facet => facet.attribute === SEARCH_API_FILTERS['brands'])
  if (brandsFacets && brandsFacets[0] && brandsFacets[0].buckets && brandsFacets[0].buckets.length > 0) {
    const collections = brandsFacets[0].buckets.filter(bucket => bucket.count > 0).map(bucket => bucket.value)

    updateFilterValues('brands', collections)
  }

  const concernsFacets = facets.filter(facet => facet.attribute === SEARCH_API_FILTERS['concerns'])
  if (concernsFacets && concernsFacets[0] && concernsFacets[0].buckets && concernsFacets[0].buckets.length > 0) {
    const concerns = concernsFacets[0].buckets.filter(bucket => bucket.count > 0).map(bucket => bucket.value)

    updateFilterValues('concern-need', concerns)
  }

  const ingredientFacets = facets.filter(facet => facet.attribute === SEARCH_API_FILTERS['ingredients'])
  if (ingredientFacets && ingredientFacets[0] && ingredientFacets[0].buckets && ingredientFacets[0].buckets.length > 0) {
    const ingredients = ingredientFacets[0].buckets.filter(bucket => bucket.count > 0).map(bucket => bucket.value)

    updateFilterValues('ingredient', ingredients)
  }

  if (!fromInitialLoad) {
    // not updating the top level filters as we only need to handle those once
    return
  }

  const allTopFilters = []
  const allSecondaryFilters = []
  const allTertiaryFilters = []

  const topFacet = facets.filter(facet => facet.attribute === SEARCH_API_FILTERS['top_category'])
  if (topFacet) {
    allTopFilters.push(...topFacet[0].buckets.filter(bucket => bucket.count > 0).map(bucket => bucket.value))
  }

  const middleFacet = facets.filter(facet => facet.attribute === SEARCH_API_FILTERS['secondary_category'])
  if (middleFacet) {
    allSecondaryFilters.push(...middleFacet[0].buckets.filter(bucket => bucket.count > 0).map(bucket => bucket.value))
  }

  const thirdFacet = facets.filter(facet => facet.attribute === SEARCH_API_FILTERS['tertiary_category'])
  if (thirdFacet) {
    allTertiaryFilters.push(...thirdFacet[0].buckets.filter(bucket => bucket.count > 0).map(bucket => bucket.value))
  }

  const availableHierarchies = [];

  const currentCollectionCategoryTypes = (COLLECTION_ALL_PRODUCT_TYPES || []).map(item => formatCategoryName(item.trim()))

  for (const topCategory in ALL_CATEGORY_HIERARCHIES) {
    if (allTopFilters.includes(topCategory)) {
      const secondaryCategories = ALL_CATEGORY_HIERARCHIES[topCategory];
      for (const secondaryCategory in secondaryCategories) {
        if (allSecondaryFilters.includes(secondaryCategory)) {
          const tertiaryCategories = secondaryCategories[secondaryCategory];
          const availableTertiary = tertiaryCategories.filter(tertiary => allTertiaryFilters.includes(tertiary));

          if (availableTertiary.length > 0) {
            const filteredTertiaries = []
            if (currentCollectionCategoryTypes.length > 0) {
              availableTertiary.forEach(tertiary => {
                if (currentCollectionCategoryTypes.includes(`${topCategory}, ${secondaryCategory}, ${tertiary}`)) {
                  filteredTertiaries.push(tertiary)
                }
              })
            } else {
              filteredTertiaries.push(...availableTertiary)
            }

            if (filteredTertiaries.length > 0) {
              availableHierarchies.push({
                top: topCategory,
                secondary: secondaryCategory,
                tertiary: filteredTertiaries
              })
            }
          }
          else {
            // if there actually is no tertiaries at all then consider it available
            if (tertiaryCategories.length === 0) {
              availableHierarchies.push({
                top: topCategory,
                secondary: secondaryCategory,
                tertiary: []
              })
            }
          }
        }
      }
    }
  }

  const finalHierarchyFormat = {};
  availableHierarchies.forEach(hierarchy => {
    if (!finalHierarchyFormat[hierarchy.top]) {
      finalHierarchyFormat[hierarchy.top] = {};
    }

    finalHierarchyFormat[hierarchy.top][hierarchy.secondary] = hierarchy.tertiary;
  })

  handleCategoryHierarchy(finalHierarchyFormat)
}

function setSearchPageHeader(query, response) {
  const searchPageHeader = document.querySelector('.page-search-results-header')

  if (!searchPageHeader) { return }

  const collectionWrapper = document.querySelector('.main-collection_wrapper')

  if (collectionWrapper) {
    collectionWrapper.removeAttribute('style')
  }

  const searchTitle = searchPageHeader.querySelector('.page-search-results-header-title')

  const sanitizedSearchQuery = decodeURI(query).replace(/\+/g, ' ')

  searchTitle.innerText = `Showing search results for "${sanitizedSearchQuery}"`

  const clearButton = searchPageHeader.querySelector('.page-search-results-header-form-close')

  clearButton.addEventListener('click', (e) => {
    e.preventDefault()

    const searchInput = searchPageHeader.querySelector('.page-search-results-header-form-input')
    searchInput.value = ''

    return false
  })

  const form = searchPageHeader.querySelector('.page-search-results-header-form')
  form.addEventListener('submit', (event) => {
    event.preventDefault()

    const searchInput = searchPageHeader.querySelector('.page-search-results-header-form-input')
    const searchQuery = searchInput.value

    window.location = '/search?q=' + encodeURI(searchQuery)

    return false
  })

  const searchInput = searchPageHeader.querySelector('.page-search-results-header-form-input')
  searchInput.value = sanitizedSearchQuery

  if (response.categories.length > 0) {
    const listContainer = searchPageHeader.querySelector('.page-search-results-header-quick-links-wrapper')

    const newListEl = document.createElement('ul')
    newListEl.classList.add('snize-quick-link-search-results')

    listContainer.innerHTML = ''

    listContainer.appendChild(newListEl)

    // for the first 10 responses...
    response.categories.slice(0, 10).forEach(category => {
      const newListItemEl = document.createElement('li')
      newListItemEl.classList.add('snize-quick-link-search-result')

      const newLinkEl = document.createElement('a')
      newLinkEl.classList.add('snize-quick-link-search-result-link')

      newLinkEl.href = category.link
      newLinkEl.innerText = category.title

      newListItemEl.appendChild(newLinkEl)

      newListEl.appendChild(newListItemEl)
    })
  } else {
    const listContainer = searchPageHeader.querySelector('.page-search-results-header-quick-links-wrapper')
    listContainer.classList.add('hidden')

    const listHeader = searchPageHeader.querySelector('.page-search-results-header-quick-links')
    listHeader.classList.add('hidden')
  }
}

function getAvailableFilters() {
  const baseURL = 'https://searchserverapi.com/getresults'
  const params = new URLSearchParams({
    apiKey: window.SEARCH_API_KEY,
    items: false,
    facets: true,
    categories: true
  })

  if (COLLECTION_TITLE) {
    params.append('restrictBy[collections]', COLLECTION_TITLE)
  }

  const urlParams = new URLSearchParams(window.location.search)
  if (urlParams.get('q')) {
    params.append('q', urlParams.get('q'))
    params.append('categories', true)
  }

  fetch(`${baseURL}?${params}`)
    .then((response) => response.json())
    .then((response) => {
      updateFiltersFromFacets(response.facets, new URLSearchParams(window.location.search), true);
      updateCategoriesFromSearch(response.categories);

      if (urlParams.get('q')) {
        setSearchPageHeader(urlParams.get('q'), response)
      }
    })
}

function updateCategoriesFromSearch(categories) {
  const relatedSearchestList = document.querySelector('.related-searches-list');

  if (!relatedSearchestList) {
    return
  }

  if(!categories || categories.length < 1) {
    relatedSearchestList.style.display = 'none'
    return
  };

  for (var i = categories.length - 1; i >= 0; i--) {
    var title = categories[i].title;
    if(title.length > 20) title = title.substring(0,20) + '...';
    const relatedSearchesTemplate = `<a class="related-searches-item" href="${categories[i].link}">${title}</a>`
    relatedSearchestList.innerHTML = relatedSearchestList.innerHTML + relatedSearchesTemplate;
  }
}

function calculatePageInfo(payload) {
  const totalItems = payload.totalItems;
  const itemsPerPage = payload.itemsPerPage;
  const startIndex = payload.startIndex;

  const numPages = Math.ceil(totalItems / itemsPerPage);
  const currentPage = Math.floor(startIndex / itemsPerPage) + 1;

  return { currentPage, numPages };
}

function updatePageFilter(filters) {
  const category = filters.get('category')
  const secondary = filters.get('secondary')
  const brand = filters.get('brands')
  const concern = filters.get('concerns')
  const ingredients = filters.get('ingredients')
  const order = filters.get('order')
  const sort = filters.get('sort')
  const query = filters.get('q')
  const page = filters.get('page')

  const baseURL = 'https://searchserverapi.com/getresults'
  const params = new URLSearchParams({
    apiKey: window.SEARCH_API_KEY,
    maxResults: 24,
    facets: true
  })

  if (COLLECTION_TITLE) {
    params.append('restrictBy[collections]', COLLECTION_TITLE)
    params.append('sortOrder', 'desc')
    params.append('sortBy', 'sales_amount')
  }

  if (rootCategorySplit.length > 0) {
    if (rootCategorySplit.length > 1) {
      // category --> secondary category
      // secondary --> tertiary category
      if (secondary && secondary !== 'null') {
        params.append('restrictBy[' + SEARCH_API_FILTERS['top_category'] + ']', rootCategorySplit[0])
        params.append('restrictBy[' + SEARCH_API_FILTERS['secondary_category'] + ']', category)
        params.append('restrictBy[' + SEARCH_API_FILTERS['tertiary_category'] + ']', secondary)
      }
    } else if (rootCategorySplit.length === 1) {
      if (category && category !== 'null') {
        params.append('restrictBy[' + SEARCH_API_FILTERS['top_category'] + ']', category)
      }
      if (secondary && secondary !== 'null') {
        params.append('restrictBy[' + SEARCH_API_FILTERS['secondary_category'] + ']', secondary)
      }
    }
  }
  else {
    // category --> top level category
    // secondary --> secondary category
    if (category && category != 'null') {
      params.append('restrictBy[' + SEARCH_API_FILTERS['top_category'] + ']', category)
    }

    if (secondary && secondary != 'null') {
      params.append('restrictBy[' + SEARCH_API_FILTERS['secondary_category'] + ']', secondary)
    }
  }

  if (brand) {
    params.append('restrictBy[vendor]', brand)
  }

  if (concern) {
    params.append('restrictBy[' + SEARCH_API_FILTERS['concerns'] + ']', concern)
  }

  if (ingredients) {
    params.append('restrictBy[' + SEARCH_API_FILTERS['ingredients'] + ']', ingredients)
  }

  if (sort) {
    params.append('sortBy', sort)
  }

  if (order) {
    params.append('sortOrder', order)
  }

  if (query) {
    params.append('q', query)
  }

  if (page && page > 1) {
    params.append('startIndex', (page - 1) * 24)
  }

  fetch(`${baseURL}?${params}`)
    .then((response) => response.json())
    .then((response) => {
      const loadingDiv = document.querySelector('.product-grid-container .collection.loading')

      if (loadingDiv) {
        loadingDiv.classList.remove('loading')
      }

      renderFilterProducts(response.items)
      updatePagination(response)

      // If it's a search page update the number of results in the page title
      if (document.title.startsWith('Search: ') && response.totalItems) {
        document.title = document.title.replace(/Search: \d+ results/, `Search: ${response.totalItems} results`)
      }

      // Update the URL to reflect latest filters
      const currentSearchParams = new URLSearchParams(window.location.search)

      if (category && category != 'null') {
        currentSearchParams.set('category', category)
      } else {
        currentSearchParams.delete('category')
      }

      if (secondary && secondary != 'null') {
        currentSearchParams.set('secondary', secondary)
      } else {
        currentSearchParams.delete('secondary')
      }

      if (brand) {
        currentSearchParams.set('brands', brand)
      } else {
        currentSearchParams.delete('brands')
      }

      if (concern) {
        currentSearchParams.set('concerns', concern)
      } else {
        currentSearchParams.delete('concerns')
      }

      if (ingredients) {
        currentSearchParams.set('ingredients', ingredients)
      } else {
        currentSearchParams.delete('ingredients')
      }

      if (sort) {
        currentSearchParams.set('sort', sort)
      } else {
        currentSearchParams.delete('sort')
      }

      if (order) {
        currentSearchParams.set('order', order)
      } else {
        currentSearchParams.delete('order')
      }

      if (query) {
        currentSearchParams.set('q', query)
      } else {
        currentSearchParams.delete('q')
      }

      if (page && page > 1) {
        currentSearchParams.set('page', page)
      } else {
        currentSearchParams.delete('page')
      }

      const newURL = `${window.location.pathname}?${currentSearchParams}`
      window.history.pushState({ path: newURL }, '', newURL)

      updateFiltersFromFacets(response.facets, currentSearchParams)
    });
}

function combineWithCurrentURL(paramsString) {
  const currentParams = new URLSearchParams(window.location.search)
  const newParams = new URLSearchParams(paramsString)

  for (let [key, value] of newParams.entries()) {
      currentParams.set(key, value)
  }

  return currentParams
}

function removeFiltersButtons(value) {
  const filterHeaderButtons = document.querySelectorAll('[data-collection-filter-header-item]')
  filterHeaderButtons && filterHeaderButtons.forEach(button => {
    if (button.dataset.filterHeaderValue == value) { button.remove() }
  })
}

function closeFilterOptions(value, type) {
  const currentParams = new URLSearchParams(window.location.search)
  if (type === 'brands') {
    const currentFilter = currentParams.get('brands')
    if (currentFilter === value) {
      currentParams.delete('brands')
    } else if (currentFilter.indexOf('|') > -1) {
      const newFilter = currentFilter.replace(`${value}|`, '').replace(`|${value}`, '').replace(value, '')
      currentParams.set('brands', newFilter)
    } else {
      currentParams.delete('brands')
    }
  } else if (type === 'concern-need') {
    const currentFilter = currentParams.get('concerns')
    if (currentFilter === value) {
      currentParams.delete('concerns')
    } else if (currentFilter.indexOf('|') > -1) {
      const newFilter = currentFilter.replace(`${value}|`, '').replace(`|${value}`, '').replace(value, '')
      currentParams.set('concerns', newFilter)
    } else {
      currentParams.delete('concerns')
    }
  } else if (type === 'ingredient') {
    const currentFilter = currentParams.get('ingredients')
    if (currentFilter === value) {
      currentParams.delete('ingredients')
    } else if (currentFilter.indexOf('|') > -1) {
      const newFilter = currentFilter.replace(`${value}|`, '').replace(`|${value}`, '').replace(value, '')
      currentParams.set('ingredients', newFilter)
    } else {
      currentParams.delete('ingredients')
    }
  }
  updatePageFilter(currentParams)
  removeFiltersButtons(value)
}

function updateFilterHeader (type, value) {
  const filtersHeaderOptions = document.querySelector('[data-collection-filter-header]')
  if (!filtersHeaderOptions) {
    console.log("filtersHeaderOptions not found")
    return
  }
  const filterHeaderHtml = `
    <div data-collection-filter-header-item class="collection-filter-header-item" data-filter-header-value="${value}">
      <span class="collection-filter-header-item-text">${value}</span>
      <a data-collection-filter-close="${value}" class="collection-filter-header-item-close" onclick="closeFilterOptions('${value}','${type}')">✕</a>
    </div>
  `
  filtersHeaderOptions.insertAdjacentHTML('beforeend', filterHeaderHtml)
}

const onFilterTriggered = (event) => {
  const currentParams = new URLSearchParams(window.location.search)

  const { type, value, checked } = event.detail

  if (!value || !type) {
    return
  }

  console.log('currentParams:', currentParams.toString())

  if (checked) {
    // we just tried to add a filter
    console.log(`Need to add a new filter: ${type}: ${value}`)

    if (type === 'brands') {
      const currentFilter = currentParams.get('brands')
      if (currentFilter) {
        currentParams.set('brands', `${currentFilter}|${value}`)
      } else {
        currentParams.set('brands', value)
      }
    } else if (type === 'concern-need') {
      const currentFilter = currentParams.get('concerns')
      if (currentFilter) {
        currentParams.set('concerns', `${currentFilter}|${value}`)
      } else {
        currentParams.set('concerns', value)
      }
    } else if (type === 'ingredient') {
      const currentFilter = currentParams.get('ingredients')
      if (currentFilter) {
        currentParams.set('ingredients', `${currentFilter}|${value}`)
      } else {
        currentParams.set('ingredients', value)
      }
    }

    updateFilterHeader(type, value)

  } else {
    // we just tried to remove a filter
    console.log(`Need to remove a filter: ${type}: ${value}`)

    if (type === 'brands') {
      const currentFilter = currentParams.get('brands')
      if (currentFilter === value) {
        currentParams.delete('brands')
      } else if (currentFilter.indexOf('|') > -1) {
        const newFilter = currentFilter.replace(`${value}|`, '').replace(`|${value}`, '').replace(value, '')
        currentParams.set('brands', newFilter)
      } else {
        currentParams.delete('brands')
      }
    } else if (type === 'concern-need') {
      const currentFilter = currentParams.get('concerns')
      if (currentFilter === value) {
        currentParams.delete('concerns')
      } else if (currentFilter.indexOf('|') > -1) {
        const newFilter = currentFilter.replace(`${value}|`, '').replace(`|${value}`, '').replace(value, '')
        currentParams.set('concerns', newFilter)
      } else {
        currentParams.delete('concerns')
      }
    } else if (type === 'ingredient') {
      const currentFilter = currentParams.get('ingredients')
      if (currentFilter === value) {
        currentParams.delete('ingredients')
      } else if (currentFilter.indexOf('|') > -1) {
        const newFilter = currentFilter.replace(`${value}|`, '').replace(`|${value}`, '').replace(value, '')
        currentParams.set('ingredients', newFilter)
      } else {
        currentParams.delete('ingredients')
      }
    }
    removeFiltersButtons(value)
  }

  updatePageFilter(currentParams)
}

document.addEventListener('facetsRenderPageTriggered', onFilterTriggered)

const onSortChanged = (event) => {
  const sortType = event.detail.value

  let newSortType = ''
  let newSortDirection = ''

  if (sortType === 'created-ascending') {
    newSortType = 'created'
  } else if (sortType === 'price-ascending') {
    newSortType = 'price'
  } else if (sortType === 'price-descending') {
    newSortType = 'price'
    newSortDirection = 'desc'
  } else if (sortType === 'title-ascending') {
    newSortType = 'title'
  } else if (sortType === 'title-descending') {
    newSortType = 'title'
    newSortDirection = 'desc'
  }

  const currentParams = new URLSearchParams(window.location.search)

  if (!newSortType && currentParams.has('sort')) {
    currentParams.delete('sort')
  } else if (newSortType) {
    currentParams.set('sort', newSortType)
  }

  if (!newSortDirection && currentParams.has('order')) {
    currentParams.delete('order')
  } else if (newSortDirection) {
    currentParams.set('order', newSortDirection)
  }

  updatePageFilter(currentParams)
}

document.addEventListener('facetsOrderChange', onSortChanged)

getAvailableFilters()

function mobileResetFilters() {
  updatePageFilter(new URLSearchParams(''))

  const mobileFacets = document.querySelector('.mobile-facets__disclosure')

  if (mobileFacets) {
    mobileFacets.classList.remove('menu-opening')
    mobileFacets.removeAttribute('open')
  }
  document.body.classList.remove('overflow-hidden-mobile');
}

function mobileApplyFilters() {
  document.body.classList.remove('overflow-hidden-mobile');
}

document.addEventListener('DOMContentLoaded', () => {
  const pageLoadParams = new URLSearchParams(window.location.search)
  if (pageLoadParams.has('q') || pageLoadParams.has('brands') || pageLoadParams.has('concerns') || pageLoadParams.has('ingredients') || pageLoadParams.has('sort') || pageLoadParams.has('order')) {
    updatePageFilter(new URLSearchParams(window.location.search))
  }

  // ensure any URL param filters are reflected in UI on page load
  const updatedParams = new URLSearchParams(window.location.search)
  if (updatedParams.get('brands')) {
    const allSelectedBrands = updatedParams.get('brands').split('|')
    allSelectedBrands.forEach(b => {
      const fieldInput = document.querySelector(`#FacetFiltersForm input[name='brands'][value='${b}']`)
      if (fieldInput) { fieldInput.checked = true }
      const mobileFieldInput = document.querySelector(`#FacetFiltersFormMobile input[name='brands'][value='${b}']`)
      if (mobileFieldInput) { mobileFieldInput.checked = true }
    })
    allSelectedBrands[0] && (document.querySelector('#FacetFiltersForm input[name="brands"]:checked').closest('details').open = 'open')
    allSelectedBrands[0] && (document.querySelector('#FacetFiltersFormMobile input[name="brands"]:checked').closest('details').open = 'open')
  }
  if (updatedParams.get('concern')) {
    const allSelectedConcerns = updatedParams.get('concern').split('|')
    allSelectedConcerns.forEach(c => {
      const fieldInput = document.querySelector(`#FacetFiltersForm input[name='concern-need'][value='${c}']`)
      if (fieldInput) { fieldInput.checked = true }
      const mobileFieldInput = document.querySelector(`#FacetFiltersFormMobile input[name='concern-need'][value='${c}']`)
      if (mobileFieldInput) { mobileFieldInput.checked = true }
    })
    allSelectedConcerns[0] && (document.querySelector('#FacetFiltersForm input[name="concern-need"]:checked').closest('details').open = 'open')
    allSelectedConcerns[0] && (document.querySelector('#FacetFiltersFormMobile input[name="concern-need"]:checked').closest('details').open = 'open')
  }
  if (updatedParams.get('ingredient')) {
    const allSelectedIngredients = updatedParams.get('ingredient').split('|')
    allSelectedIngredients.forEach(i => {
      const fieldInput = document.querySelector(`#FacetFiltersForm input[name='ingredient'][value='${i}']`)
      if (fieldInput) { fieldInput.checked = true }
      const mobileFieldInput = document.querySelector(`#FacetFiltersFormMobile input[name='ingredient'][value='${i}']`)
      if (mobileFieldInput) { mobileFieldInput.checked = true }
    })
    allSelectedIngredients[0] && (document.querySelector('#FacetFiltersForm input[name="ingredient"]:checked').closest('details').open = 'open')
    allSelectedIngredients[0] && (document.querySelector('#FacetFiltersFormMobile input[name="ingredient"]:checked').closest('details').open = 'open')
  }
})